import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { MarkerClusterer } from '@googlemaps/markerclusterer';
import { Coordinates } from 'src/app/models/Coordinates';
import { Ope } from 'src/app/models/Ope';
import { PostionCoordinate } from 'src/app/models/PositionCoordinate';
import { DocServices } from 'src/app/services/docs/docs.services';
import { OpeService } from 'src/app/services/ope/ope.service';
import { PersistanceService } from 'src/app/services/persistenceStorage/localstorage.service';
import { sharePitSevices } from 'src/app/services/pitupload/sharePit.service';


@Component({
  selector: 'app-map-single-pit',
  templateUrl: './map-single-pit.component.html',
  styleUrls: ['./map-single-pit.component.scss']
})
export class MapSinglePitComponent {

  coordinates: Coordinates[] = [];
  //map!: google.maps.Map;
  center: google.maps.LatLngLiteral = { lat: 48.866667, lng: 2.333333 };
  geocoder: google.maps.Geocoder = new google.maps.Geocoder();
  markers = [];

  locations: PostionCoordinate[] = [];


  constructor(public share: sharePitSevices, private readonly docsndVigneteService: DocServices,
    private readonly router: Router, private readonly opeService: OpeService, private readonly persist: PersistanceService) {

  }

  ngOnInit(): void {


    this.coordinates = []
    this.initMapo();

  }
  initMapo() {
    this.getLocations();
  }

  programmSelected!: Ope;

  openOpe(ope: Ope): void {
    //const pageCard = new  CardComponent(this.share, this.opeService,this.router,this.docsndVigneteService, this.persist);
    //pageCard.sendOpeclickOut( ope);
  }

  getLocations() {
    this.share.opeSelected.subscribe(data => {
      this.getMap([data]);
    });
  }

  contentInfoMap(info: Ope): string {
    return `<div id="content" style="cursor: pointer;color:#000;width: 190px; height: 65px;padding: 12px; box-sizing: border-box; font-family: Assistant, Arial, Helvetica, sans-serif; display: flex; flex-direction: column; justify-content: space-between;">
                  <div>
                  <h2 style="margin: 0; font-size: 1em; font-weight: bold;">${info.nom}</h2>
                  <p style="margin: 2px 0; font-size: 0.8rem; ">${info.ville} (${info.codePostal})</p>
                  </div>
                </div>`;
  }

  async getMap(data: Ope[]) {

    const { Map, InfoWindow } = await google.maps.importLibrary("maps") as google.maps.MapsLibrary;
    const { AdvancedMarkerElement, PinElement } = await google.maps.importLibrary("marker") as google.maps.MarkerLibrary;

    const infoWindow = new google.maps.InfoWindow({
      content: "",
      disableAutoPan: true,
    });

    await this.codeAddress(data);
    let paris = { lat: 47.081012, lng: 2.398782 }
    let zoom = 5.6
    let mapTypeControl = false;
    let streetViewControl = false
    let panControl = false;
    let zoomControl = true;
    let scrollwheel = true;
    let scaleControl = true;
    let draggable = true;

    if (data.length === 1) {

      paris = this.coordinates[0].position;
      zoom = 15;
      mapTypeControl = false;
      streetViewControl = false
      panControl = false;
      zoomControl = true;
      scrollwheel = true;
      scaleControl = true;
      draggable = true;
    }

    let mapoo = document.getElementById("mapoo");
    if (mapoo == null) {
      mapoo = document.createElement('div');
      mapoo.setAttribute("id", "mapoo");
    }
    const map = new google.maps.Map(
      mapoo as HTMLElement,
      {
        zoom: zoom,
        center: paris,
        mapId: 'SINGLE_MAP',
        mapTypeControl: mapTypeControl,
        streetViewControl: streetViewControl,
        panControl: panControl,
        zoomControl: zoomControl,
        scrollwheel: scrollwheel,
        scaleControl: scaleControl,
        draggable: draggable,
        mapTypeId: google.maps.MapTypeId.ROADMAP
      }
    );

    const markers = this.coordinates.map((pos) => {
      const ppose = pos.position;
      const label = "";
      let dispo = document.createElement('span');
      dispo.style.cssText = "  background: radial-gradient( 5px -9px, circle, white 8%, red 26px );    background-color: green;    border: 2px solid white;    border-radius: 12px; /* one half of ( (border * 2) + height + padding ) */    box-shadow: 1px 1px 1px black;    color: white;    font: bold 15px/13px Helvetica, Verdana, Tahoma;    height: 16px;    min-width: 14px;    padding: 4px 3px 0 3px;    text-align: center;"
      dispo.textContent = "" + pos.ope.disponibles;
      var marker: google.maps.MVCObject | google.maps.marker.AdvancedMarkerElement | null | undefined;
      if (data.length > 1) {
        marker = new google.maps.marker.AdvancedMarkerElement({
          content: dispo,
          position: ppose,
        });
      } else {
        marker = new google.maps.marker.AdvancedMarkerElement({
          position: ppose,
        });
      }
      marker.addListener("gmp-click", () => {
        infoWindow.setContent(this.contentInfoMap(pos.ope));
        infoWindow.open(map, marker);
        infoWindow.addListener('domready', () => {
          document.getElementById("content")!.addEventListener("click", () => {
            this.openOpe(pos.ope);
          });
        });
      });
      return marker;
    });

    const markerscluster = new MarkerClusterer({

      onClusterClick: (e, cluster) => {
        if (map.getZoom()) {
          const s = map.getZoom();
          map.setZoom(s! + 1);
        }
      },
      markers,
      map
    });
    this.coordinates = [];

  }


  async codeAddress(data: Ope[]) {

    for (const cdt of data) {

      if (cdt != null) {
        await this.geocoder.geocode({ address: cdt.adresse1 + " " + cdt.ville }, (results, status) => {
          if (status === 'OK') {
            if (results != null) {
              var latLng = { lat: results?.[0].geometry.location.lat(), lng: results?.[0].geometry.location.lng() };
              this.locations.push(latLng);
              this.coordinates.push(new Coordinates(latLng, cdt.nom, "", cdt.adresse1 + " " + cdt.ville, cdt))
            }
          }
        });
      }

    }
  }

}
